import { DashboardService } from "../../../dashboard.service";
import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { MyAccountService } from "../modals/my-account-modal.service";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { HotToastService } from "@ngneat/hot-toast";
import { Subject } from "rxjs";
import {
  FormControl,
  FormGroup,
  Validators,
  FormsModule,
} from "@angular/forms";
import {
  CountryISO,
  PhoneNumberFormat,
  SearchCountryField,
  NgxIntlTelInputModule,
} from "@justin-s/ngx-intl-tel-input";
import { CodeInputModule } from "angular-code-input";
import { NgIf } from "@angular/common";

/* This is a component which we pass in modal*/
@Component({
    selector: "ch-sms-verification-modal",
    templateUrl: "./sms-verification-modal.component.html",
    styleUrls: ["./sms-verification-modal.component.scss"],
    imports: [NgIf, NgxIntlTelInputModule, FormsModule, CodeInputModule]
})
export class SmsVerificationModalComponent implements OnInit {
  user: any = {};
  data: any = { phone_number: "" };
  showLoading = false;
  verificationCode: string;
  isTokenCreated: boolean = false;
  tokenVerificationError: boolean = false;

  phoneInput: any;

  // For phone number input
  separateDialCode = true;
  public SearchCountryField = SearchCountryField;
  public CountryISO = CountryISO;
  public PhoneNumberFormat = PhoneNumberFormat;
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required]),
  });

  fromLogin = false;
  phoneNumber = "";

  phone_info = {
    phone_number: "",
    is_phone_number_verified: false,
    is_2fa_enabled: false,
  };

  mockNumber = "";
  userUuid = "";

  public onClose: Subject<any>;

  constructor(
    public bsModalRef: BsModalRef,
    private myAccountService: MyAccountService,
    private localStorage: LocalStorageService,
    private toastr: HotToastService,
  ) {}

  public ngOnInit(): void {
    this.user = this.localStorage.get("user");
    this.data = this.localStorage.get("data");

    this.onClose = new Subject();

    if (!this.fromLogin) {
      console.log("Calling get_2fa_status");
      this.myAccountService.get_2fa_status().then((res) => {
        this.phone_info = res;
        this.data.phone_number = this.phone_info.phone_number;
        this.phoneInput = this.phone_info.phone_number;
      });
    } else {
      // this.phone_info.phone_number = this.phoneNumber;
      // this.data = { phone_number: this.phoneNumber };
      console.log(this.mockNumber);
      console.log(this.userUuid);
      this.isTokenCreated = true;
    }
  }

  closeModal(reason = null) {
    this.onClose.next(reason);
    this.bsModalRef.hide();
  }

  generateSmsToken() {
    this.myAccountService.generate_sms_token(this.phoneInput.e164Number).then(
      (res) => {
        // this.dashboardService.show_loading.next(false);
        this.toastr.success(res.message);
        this.isTokenCreated = res.generated;
      },
      (err) => {
        // this.dashboardService.show_loading.next(false);
        this.toastr.error(err.error.message);
      },
    );
  }

  verifySmsCode() {
    //   this.dashboardService.show_loading.next(true);
    let verification_function = this.fromLogin
      ? this.myAccountService.verify_sms_token_phone(
          this.userUuid,
          this.verificationCode,
        )
      : this.myAccountService.verify_sms_token(this.verificationCode);
    verification_function.then(
      (res) => {
        // this.dashboardService.show_loading.next(false);

        this.verificationCode = "";

        if (res.is_code_valid) {
          if (this.fromLogin) {
            this.closeModal({ verified: true });
          } else {
            this.data.is_phone_number_verified = res.is_phone_number_verified;
            this.toastr.success(res.message);
            this.bsModalRef.hide();
          }
        } else {
          this.toastr.error(res.message);
          this.tokenVerificationError = true;
        }
      },
      (err) => {
        // this.dashboardService.show_loading.next(false);
        this.toastr.error(err.error.message);
      },
    );
  }

  changeNumber() {
    this.data.phone_number = "";
    this.phoneInput = {};
    this.verificationCode = "";
    this.isTokenCreated = false;
  }

  remove2FA() {
    this.myAccountService.remove_2fa().then((res) => {
      this.toastr.success("2FA removed successfully");
      this.bsModalRef.hide();
    });
  }

  // this called every time when user changed the code
  onCodeChanged(code: string) {}

  // this called only if user entered full code
  onCodeCompleted(code: string) {
    this.verificationCode = code;
    this.verifySmsCode();
  }
}
